export default {
  listTitleTable: {
    COM_GROUP_CODE: 'INDEX',
    INDEX_VALUE: 'LAST',
    INDEX_CHANGE: 'CHANGE',
    PERCENT_INDEX_CHANGE: '%1D CHANGE',
    TOTAL_MATCH_VOLUME: 'VOLUME',
    TOTAL_MATCH_VALUE: 'VALUE',
    FOREIGN_BUY_VOL_MATCHED: 'FR. BUY VOL.',
    FOREIGN_SELL_VOL_MATCHED: 'FR. SELL VOL.',
    FOREIGN_NET_VOLUME: 'FR. NET VOL.',
    FOREIGN_NET_VALUE: 'FR. NET VALUE',
    TOTAL_DEAL_VOLUME: 'PUT THROUGH VOL.',
    TOTAL_DEAL_VALUE: 'PUT THROUGH VALUE',
  },
  comGroupCode: {
    VNINDEX: 'VNINDEX',
    VN30: 'VN30',
    HNXINDEX: 'HNXINDEX',
    HNX30: 'HNX30',
    UPCOMINDEX: 'UPCOMINDEX',
    VNXALL: 'VNXALL',
    VN100: 'VN100',
    VNALL: 'VNALL',
    VNCOND: 'CONSUMER DISCRETIONARY',
    VNCONS: 'CONSUMER STAPLES',
    VNDIAMOND: 'VNDIAMOND',
    VNENE: 'ENERGY',
    VNFIN: 'FINANCIALS EX REAL ESTATE',
    VNFINLEAD: 'VNFINLEAD',
    VNFINSELECT: 'VNFINSELECT',
    VNHEAL: 'HEALTH CARE',
    VNIND: 'INDUSTRIALS',
    VNIT: 'INFORMATION TECHNOLOGY',
    VNMAT: 'MATERIALS',
    VNMID: 'VNMID',
    VNREAL: 'REAL ESTATE',
    VNUTI: 'UTILITIES',
    VNX50: 'VNX50',
  },
};
